import { MethodOfAssessment } from 'src/app/enums/methodOfAssessment.enum';
import { Units } from 'src/app/enums/units.enum';

export interface SegProfileAgentResponse {
    id: string;
    name: string;
}

export interface SegProfileRowResponse {
    segId: string;
    segName: string;
    agentId: string;
    agentName: string;
    methodOfAssessment: MethodOfAssessment;
    assessedLikelihoodScore: number | null;
    assessedBandName: string;
    assessedBandColor: string;
    assessedBandRange: string;
    currentLikelihoodScore: number | null;
    currentBandName: string;
    currentBandColor: string;
    currentBandRange: string;
    decisionStatisticPercentOfOel: number | null;
    trendDirection: number | null;
    liveSampleCount: number;
    oelNotSet: boolean;
    numberOfWorkers: number | null;
    numberOfContractors: number | null;
    geoStdDev: number | null;
    isNormal: boolean | null;
    isLogNormal: boolean | null;
    decisionStatisticValue: number | null;
    agentUnits: Units | null;
    plannedNumberOfSamples: number | null;
}

export interface SegGroupPlanResponse {
    segId: string;
    segName: string;
    agentGroupId: string;
    agentGroupName: string;
    year: number;
    plannedNumberOfSamples: number;
    actualCount: number;
}

/**
 * Per-(SegId, JobDictionaryId) sample rollup returned by SegProfile/GetSummary.
 * Mirrors the BE `SegJobRollupDto`. The SEG Profile report merges these into the report feed by
 * `segId` so each SEG's Job Roles table lists its job classifications and sample counts.
 */
export interface SegJobRollupResponse {
    segId: string | null;
    jobDictionaryId: string | null;
    jobName: string;
    sampleCount: number;
}

export interface SegProfileSummaryResponse {
    orgLevelName: string;
    currentRiskAssessmentId: string | null;
    currentRiskAssessmentName: string | null;
    decisionStatistic: number | null;
    jurisdictionId: string | null;
    jurisdictionName: string | null;
    availableAgents: SegProfileAgentResponse[];
    rows: SegProfileRowResponse[];
    groupPlans: SegGroupPlanResponse[];
    segJobRollup: SegJobRollupResponse[];
}

export interface SegProfileSummaryRequest {
    organizationLevelId: string;
    windowStart: number | null;
    windowEnd: number | null;
    agentId: string | null;
    surveyTypeIds?: string[];
}
